// actionTypes.js
export const FETCH_AWR_LIST_REQUEST = 'FETCH_AWR_LIST_REQUEST';
export const FETCH_AWR_LIST_SUCCESS = 'FETCH_AWR_LIST_SUCCESS';
export const FETCH_AWR_LIST_FAILURE = 'FETCH_AWR_LIST_FAILURE';


// AWR Detail By ID
export const FETCH_AWR_DETAILS_BY_INVOICE_ID_REQUEST = 'FETCH_AWR_DETAILS_BY_INVOICE_ID_REQUEST';
export const FETCH_AWR_DETAILS_BY_INVOICE_ID_SUCCESS = 'FETCH_AWR_DETAILS_BY_INVOICE_ID_SUCCESS';
export const FETCH_AWR_DETAILS_BY_INVOICE_ID_FAILURE = 'FETCH_AWR_DETAILS_BY_INVOICE_ID_FAILURE';

// Add AWR
export const ADD_AWR_REQUEST = 'ADD_AWR_REQUEST';
export const ADD_AWR_SUCCESS = 'ADD_AWR_SUCCESS';
export const ADD_AWR_FAILURE = 'ADD_AWR_FAILURE';


// Get Invoices by AWR details
export const GET_INVOICES_BY_AWR_DETAILS_REQUEST = 'GET_INVOICES_BY_AWR_DETAILS_REQUEST';
export const GET_INVOICES_BY_AWR_DETAILS_SUCCESS = 'GET_INVOICES_BY_AWR_DETAILS_SUCCESS';
export const GET_INVOICES_BY_AWR_DETAILS_FAILURE = 'GET_INVOICES_BY_AWR_DETAILS_FAILURE';

